export const GET_RANDOM_JOKE = 'GET_RANDOM_JOKE';
export const GET_CATEGORIES = 'GET_CATEGORIES';
export const GET_CATEGORY_JOKE = 'GET_CATEGORY_JOKE';
export const GET_SEARCH_JOKE = 'GET_SEARCH_JOKE';
export const SET_LOADING = 'SET_LOADING';
export const ADD_FAVOURITE = 'ADD_FAVOURITE';
export const REMOVE_FAVOURITE = 'REMOVE_FAVOURITE';
export const GET_FAVOURITE_JOKES = 'GET_FAVOURITE_JOKES';